import React from 'react';
import { connect } from 'react-redux';
import uniquid from 'uniqid';
import AppleSignin from 'react-apple-signin-auth';
import LinkButton from "../LinkButton";
import Button from '../Button';
import FieldRow from '../FieldRow';
import { authShowRecoverPass, authShowRegister } from '../../actions/creators';
import {loginPost,facebookLogin} from '../../actions/creators/auth';
import * as validators from '../../utils/validation';
import { openPopup } from '../../actions/creators/auth/apple';
import Recaptcha from 'react-google-invisible-recaptcha';
import styled from 'styled-components';

let emailId, passId;

const Container = styled.div`
  padding-top: 10rem;
  text-align: center;
`;

const Title = styled.h3`
  margin-bottom: 1rem;

  body.theme-market & {
    font-weight: 900 !important;
    font-size: ${(50/12.6).toFixed(2)}rem !important;
    margin-bottom: 1em;
  }

  body.theme-platinum & {
    color: var(--primary-b);
    font-weight: 700 !important;
    font-size: 2.1875rem !important;
    margin-bottom: 1em;
  }
`;

class LoginPanel extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onResolve = this.onResolve.bind(this);

    this.state = {
      email: '',
      password: '',
    };
  }

  componentDidMount() {
    emailId = uniquid();
    passId = uniquid();
  }

  onChange(prop, value) {
    this.setState({[prop]: value});
  }

  onSubmit(e) {
    e.preventDefault();

    this.recaptcha.execute();
  }

  onResolve() {
    const {email, password} = this.state;
    const captcha = this.recaptcha.getResponse();
    this.recaptcha.reset();

    this.props.loginPost(email, password, captcha);
  }

  render() {
    return (
        <React.Fragment>
          <Recaptcha
              ref={ ref => this.recaptcha = ref }
              locale="es"
              sitekey={window.localConfig.recaptcha.key}
              onResolved={ this.onResolve } />
          <Container className="container">
            <Title className="title-1">¡Holaaaa!</Title>
            <p>Ingresa con tu usuario y contraseña.</p>
            
            <form onSubmit={this.onSubmit}>
              <FieldRow id={emailId} type="email" label="Email" onChange={(e) => this.onChange('email', e.target.value)} value={this.state.email}/>
              <FieldRow id={passId} type="password" label="Contraseña" onChange={(e) => this.onChange('password', e.target.value)} value={this.state.password}/>
                
              <div className='py-3'>
                  <Button submit primary large block disabled={!validators.validateEmail(this.state.email) || !this.state.password}>Ingresar</Button>
              </div>
            </form>

            <div className="mt-3 mb-5">
              <LinkButton className="d-block mb-1" onClick={this.props.showRecoverPass}>¿Olvidaste tu contraseña?</LinkButton>
            </div>
            
            <div className="row pt-5 pb-3">
              <div className="col-6">
                <Button onClick={this.props.facebookLogin} block facebook className="mb-2"><i className="fab fa-facebook-f"></i></Button>
              </div>
              <div className="col-6">
                <Button onClick={this.props.appleLogin} block className="mb-2"><i className="fab fa-apple"></i></Button>
              </div>
            </div>
            <div>
              <LinkButton className="d-block mb-1" onClick={this.props.showRegister}>
                ¿No tienes cuenta? <span className="text-primary">Regístrate aquí</span>
              </LinkButton>
            </div>
          </Container>
        </React.Fragment>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  showRecoverPass: () => dispatch(authShowRecoverPass()),
  showRegister: () => dispatch(authShowRegister()),
  loginPost: (email, password, captcha) => dispatch(loginPost(email, password, captcha)),
  facebookLogin: () => dispatch(facebookLogin()),
  appleLogin: () => dispatch(openPopup())
});

export default connect(
    null,
    mapDispatchToProps
)(LoginPanel);